import {Typography} from "@bezlimit/bezlimit-ui";
import {observer} from "mobx-react";
import "./style.scss";

export default observer(function Title({title, subTitle}: IProps) {
    return (
        <Typography as="div" className="bl-verification-title">
            <Typography as="div" className="title">
                {title}
            </Typography>
            {subTitle && (
                <Typography as="div" className="conteiner">
                    <Typography as="div" className="sub-title">
                        {subTitle}
                    </Typography>
                </Typography>
            )}
        </Typography>
    );
});

interface IProps {
    title: string;
    subTitle?: string;
}
